import styles from "../../TransactionSetting.module.scss";
import { Button, Form, message, Select } from "antd";
import { ProvidersResponse } from "../../../../custom-hooks/useFetchOutwardTransferProviders";
import { patchData } from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { useState } from "react";
import { useQueryCache } from "react-query";

const Option = Select.Option;

interface IGeneralProps {
  transferProviders: ProvidersResponse;
}

const General = ({ transferProviders }: IGeneralProps) => {
  const [isSettingOutwardProvider, setIsSettingOutwardProvider] =
    useState(false);
  const [isSettingNameEnquiryProvider, setIsSettingNameEnquiryProvider] =
    useState(false);
  const queryCache = useQueryCache();
  const [outwardForm] = Form.useForm();
  const [nameEnquiryForm] = Form.useForm();

  const handleOutwardSave = async (values: { activeProvider: string }) => {
    if (!values?.activeProvider) return;
    setIsSettingOutwardProvider(true);
    try {
      const response = await patchData(ajaxEndpoints.SET_CURRENT_PROVIDER, {
        transferProviderId: values?.activeProvider,
      });

      if (response.status === 200) {
        await queryCache.invalidateQueries(["fetchOutwardTransferProviders"]);
        message.success(response.data.message);
      }
    } catch (error: any) {
      message.error(error.message || "Failed to set current provider");
    } finally {
      setIsSettingOutwardProvider(false);
    }
  };

  const handleNameEnquirySave = async (values: {
    activeNameEnquiryProvider: string;
  }) => {
    if (!values?.activeNameEnquiryProvider) return;
    setIsSettingNameEnquiryProvider(true);
    try {
      const response = await patchData(
        ajaxEndpoints.SET_NAME_ENQUIRY_PROVIDER,
        {
          transferProviderId: values?.activeNameEnquiryProvider,
        },
      );

      if (response.status === 200) {
        await queryCache.invalidateQueries(["fetchOutwardTransferProviders"]);
        message.success(response.data.message);
      }
    } catch (error: any) {
      message.error(error.message || "Failed to set current provider");
    } finally {
      setIsSettingNameEnquiryProvider(false);
    }
  };

  return (
    <main className={styles.payment_provider_container}>
      <Form
        form={outwardForm}
        layout="vertical"
        onFinish={handleOutwardSave}
        className={styles.selector_container}
      >
        <Form.Item
          name="activeProvider"
          label="Set outward transfer provider"
          rules={[{ required: true }]}
        >
          <Select placeholder="Select provider" size="large" className="w-full">
            {transferProviders?.data?.providers?.map((provider) => (
              <Option key={provider.id} value={provider.id}>
                <span>{provider.name}</span>
                {provider.isCurrentOutwardTransferProvider && (
                  <span
                    style={{ marginLeft: 8, color: "green", fontWeight: 600 }}
                  >
                    ✅ Active
                  </span>
                )}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item>
          <Button
            htmlType="submit"
            type="primary"
            size="large"
            loading={isSettingOutwardProvider}
          >
            Save Outward Provider
          </Button>
        </Form.Item>
      </Form>

      {/* Name Enquiry Provider */}
      <Form
        form={nameEnquiryForm}
        layout="vertical"
        onFinish={handleNameEnquirySave}
        className={styles.selector_container}
      >
        <Form.Item
          name="activeNameEnquiryProvider"
          label="Select name enquiry outward provider"
          rules={[{ required: true }]}
        >
          <Select placeholder="Select provider" size="large" className="w-full">
            {transferProviders?.data?.providers?.map((provider) => (
              <Option key={provider.id} value={provider.id}>
                <span>{provider.name}</span>
                {provider.isCurrentNameEnquiryProvider && (
                  <span
                    style={{ marginLeft: 8, color: "green", fontWeight: 600 }}
                  >
                    ✅ Active
                  </span>
                )}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item>
          <Button
            htmlType="submit"
            type="primary"
            size="large"
            loading={isSettingNameEnquiryProvider}
          >
            Save Name Enquiry Provider
          </Button>
        </Form.Item>
      </Form>
    </main>
  );
};

export default General;
